export type TGetUserTokenFunction = () => Promise<{
  isUserAuthenticated: boolean;
  tokenType: EUserTokenType;
  userToken: string;
}>;

export enum EUserTokenType {
  PHOTOSI = 'photosi',
  GUEST = 'guest',
}
